import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';
import { testHasFlag } from './utils/testHasFlag';

export const canUseSearchV2: Permission = and([
  testHasFlag(FeatureFlagType.SearchV2),
]);
